module.exports = Promise.all([parcelRequire.load("l6xiM"), parcelRequire.load("56LBA"), parcelRequire.load("c94U2")]).then(() => parcelRequire('3XoWr'));